/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Button, Popper } from "@material-ui/core";
import useStyles from "./CockpitStyleJs/styleFilter";
import { getPriorityIcon, getSentimentIcon, getIntentLabel } from "../../helpers/utilities";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import cockpitActions from "../../redux/actions/cockpitActions";
import { withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators, compose } from "redux";
import lod_ from "lodash";
import i18n from "i18n";
import UpdateConvIntentDialog from "./Convs/UpdateConvIntentDialog";
import { getMesssageItemSelector } from "redux/selectors/cockpitSelectors";
import { shallowEqual } from "helpers/utilities";
import { Add, WarningRounded } from "@material-ui/icons";

/**
 * display priority(+ update priority) + intent + sentiment
 * don't display the dropdown for priority edition in cockpitArchived page
 * @param {*} props
 * @returns
 */
function PriorityIntentSentimentDisplayerCOLD(props) {
	const { assistantconfig } = useSelector(state => state);
	const { intents } = useSelector(getMesssageItemSelector, shallowEqual);
	const [priorityAsc, setPriorityAsc] = React.useState(false);
	const dispatch = useDispatch();
	// Handle rule to display ASC priority
	useEffect(() => {
		if (props.assistantconfig.cockpit) {
			if (lod_.has(props.assistantconfig.cockpit, "update_priority_rule")) {
				//Compatibility with ancien & new config format
				if (
					props.assistantconfig.cockpit.update_priority_rule === "asc" ||
					props.assistantconfig.cockpit.update_priority_rule === true
				) {
					setPriorityAsc(true);
				}
			}
		}
	}, [props.assistantconfig.cockpit]);

	let titleComponent = <></>;

	// Get the intent code
	let intent = props.title;
	if (props?.conv?.header?.type === "review") {
		intent = props?.conv?.meta?.cockpit?.title;
	}
	// Get the label of the intent
	const label = getIntentLabel(intent, intents);

	if (props.title) {
		titleComponent = (
			<Box
				component="span"
				mx={0.5}
				style={{ paddingTop: 3, fontFamily: "Roboto", fontSize: "16px" }}
				onClick={null}
			>
				{label}
			</Box>
		);
	} else {
		<></>;
	}

	return (
		<Box
			fontWeight="fontWeightBold"
			display="flex"
			data-component-name="PriorityIntentSentimentDisplayerCOLD"
			style={{
				display: "flex",
				alignItems: "center",
				marginBottom: 5
			}}
		>
			{props?.priority && (
				<Box
					style={{
						display: "flex",
						alignItems: "center"
					}}
				>
					{getPriorityIcon(props.priority)}
				</Box>
			)}
			{titleComponent}
			{assistantconfig.cockpit?.topicMandatory &&
				!["review", "conversational"].includes(props?.conv?.header?.type) &&
				(!props?.conv?.meta?.topic ||
					props?.conv?.meta?.topic === "nointent" ||
					!assistantconfig.intents.some(obj => obj.code === props?.conv?.meta?.topic)) && (
					<>
						<Tooltip title={i18n.t("COC.noTopic")}>
							<WarningRounded style={{ color: "red" }} />
						</Tooltip>
					</>
				)}

			{props.sentiment && (
				<Box component="span" mx={0.5} style={{ paddingTop: 3 }}>
					{getSentimentIcon(props.sentiment)}
				</Box>
			)}
		</Box>
	);
}

function mapStateToProps(state) {
	return state;
}

function mapDispatchToProps(dispatch) {
	return {
		cockpitActions: bindActionCreators(cockpitActions, dispatch)
	};
}
export default compose(
	withTranslation(),
	connect(mapStateToProps, mapDispatchToProps)
)(PriorityIntentSentimentDisplayerCOLD);
